import Axios from 'axios';
import Cookies from 'js-cookie';
import { browser } from '@/lib/ua';

function base64Decode(str) {
  var c1, c2, c3, c4;
  var base64DecodeChars = new Array(
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57,
    58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0,  1,  2,  3,  4,  5,  6,
    7,  8,  9,  10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
    25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1,
    -1, -1
  );
  var i=0, len = str.length, string = '';

  while (i < len){
    do{
      c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
    } while (
    i < len && c1 == -1
      );

    if (c1 == -1) break;

    do{
      c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
    } while (
    i < len && c2 == -1
      );

    if (c2 == -1) break;

    string += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

    do{
      c3 = str.charCodeAt(i++) & 0xff;
      if (c3 == 61)
        return string;

      c3 = base64DecodeChars[c3]
    } while (
    i < len && c3 == -1
      );

    if (c3 == -1) break;

    string += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

    do{
      c4 = str.charCodeAt(i++) & 0xff;
      if (c4 == 61) return string;
      c4 = base64DecodeChars[c4]
    } while (
    i < len && c4 == -1
      );

    if (c4 == -1) break;

    string += String.fromCharCode(((c3 & 0x03) << 6) | c4)
  }
  return string;
}

function getToken() {
  const mtUserInfo = Cookies.get('MT_USER_INFO');
  if (mtUserInfo) {
    const arr = mtUserInfo.split(',');
    return base64Decode(arr[3]);
  }
  return null;
}

function getMtVersion() {
  const mtUserInfo = Cookies.get('MT_USER_INFO');
  if (mtUserInfo) {
    const arr = mtUserInfo.split(',');
    const version =  base64Decode(arr[1]);
    return parseInt(version.replace(/\./g, ''));
  } else {
    return null;
  }
}

const version = getMtVersion();

if(version == null || version < 208) {
  // window.location.href = '//m.meitun.com/inquiry/update-tip.html';//去除只在app中显示的限制
}

const UserInfo = Cookies.get('MT_USER_INFO');

window.token = getToken();
// window.token = "TLftd0g845RAVe3QSiVND0fkZP6jPMEVUiin4nu1fbY=";
window.isHaveMobile = 1;

// 普通浏览器登录
if (!UserInfo) {
  if(browser.wx){
    const userInfo=Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
    window.token =userInfo ? userInfo.token : null;
    window.isHaveMobile = userInfo ? userInfo.isHaveMobile:0;
  }else{
    localStorage.setItem('token', window.token);
    const info = {
      token: Cookies.get('mttoken') ? Cookies.get('mttoken') : null,
      encUserId: Cookies.get('mtencUserId') ? Cookies.get('mtencUserId') : null,
      avatar: Cookies.get('mtavatar') ? Cookies.get('mtavatar') : null,
      nickName: Cookies.get('mtname') ? Cookies.get('mtname') : null,
      isHaveMobile: Cookies.get('mtisHaveMobile') ? Cookies.get('mtisHaveMobile') : null,
    };
    Cookies.set('userInfo', info);
    const userInfo=Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
    const token = userInfo ? userInfo.token : null;
    window.token = token;
    window.isHaveMobile =  userInfo ? userInfo.isHaveMobile : 0;
  }
  window.isApp = 0;
}else{
  window.token = getToken();
  //如果是在app中
  window.isApp = 1;
}


window.ajaxHeader = {                      // 默认的情况下传递的参数,也可通过 requestHeader 参数传递
  clientInfo: JSON.stringify({
    clientAppVersion: '1.9.8',       // 客户端版本 （独立版）
    clientYunyuVersion: '',          // 客户端版本 （孕育版）
    clientSystem: window.navigator.userAgent,        // 客户端系统类型(如IOS、安卓)
    clientVersion: '',               // 客户端系统版本(如9.0、10.0)
    deviceCode: '',                  // 客户端标志
    latitude: '',                    // 经度
    longitude: '',                   // 维度
    traderName: '',                  // 手机型号(如iPhone 6s、iPhone7)
    partner: 'babytree',             // 渠道标志
    nettype: 'unknown',              // 网络类型标志(如WIFI、2G、3G、4G)
    clientip: '',                     // 客户端IP
    screenwidth: '',  // 设备分辨率宽度
    screenheight: '', // 设备分辨率高度
  }),
  platform: '1',                     // 平台ID,相当于老版本的apptype
  birthday: '',                      // 宝宝生日
  timestamp: Date.parse(new Date()), // 时间戳(1970年以来的秒数)
  signature: '350F163035D51E8D400114BE70EDFBFA',   // 签名，默认不校验
  protocol: document.location.protocol === 'https:' ? 'https' : 'http',      // 本次请求的用户协议类型
  token: window.token, // '3ibBaSvQgRBeA2x5c/RTcajx4AeJt0jkNK9u30t+JXY=',                   // 专家token
};

const ajaxBody = {                      // 默认的情况下传递的参数
  oem: '',
  osversion: '9.0',
  screenwidth: document.documentElement.clientWidth,
  screenheight: document.documentElement.clientWidth,
  apptype: '1',
  appversion: '2.0.0',
  nettype: 'unknown',
  regcode: '250',
  provcode: '264',
  partner: 'babytree',
  isHttps: document.location.protocol === 'https:' ? 0 : 0
};

function ajaxGet(url, obj) {
  const params = Object.assign({}, ajaxBody, obj);
  return Axios.get(url, {
    headers: window.ajaxHeader,
    params,
  }).then(response => {
    return response;
  }).catch(error => (error));
}

// post
function ajaxPost(url, obj) {
  const params = Object.assign({}, obj);
  return Axios.post(url, {
    headers: window.ajaxHeader,
    params: JSON.stringify(params),
  }).then(response => {
    return response;
  }).catch(error => (error));
}

const newAjaxHeader=window.ajaxHeader;
newAjaxHeader['Accept'] = '*/*';
function mtAjax(url, params) {
  const paramsBody = Object.assign({}, params);
  return Axios.get(url, {
      headers: newAjaxHeader,
      params:paramsBody,
    }).then(response => {
      return response;
}).catch(error => (error));
}
const api = {
  // 登录
  login() {
    return ajaxGet('/newapi/chunyu/user/userLogin', {}).then(v => (v));
  },

  // 创建问题
  createQuestion(params) {
    return ajaxGet('/newapi/chunyu/interrogation/create', params).then(v => (v));
  },

  // 公共开关，获取价格 ，已废弃
  getPrice(params) {
    return ajaxGet('/newapi/mobile/common/querySwitch', params).then(v => (v));
  },

  // 新接口
  getPriceNew(params) {
    return ajaxGet('/newapi/chunyu/interrogation/getprice', params).then(v => (v));
  },

  // 支付方式
  getPay(params) {
    return ajaxGet('/newapi/chunyu/order/paywayList', params).then(v => (v));
  },

  // 唤醒支付
  pay(params) {
    return ajaxGet('/newapi/chunyu/order/pay', params).then(v => (v));
  },

  // 我的服务列表
  getQuestions(params) {
    return ajaxGet('/newapi/chunyu/interrogation/list', params).then(v => (v));
  },

  // 删除问题
  deleteQuestion(params) {
    return ajaxGet('/newapi/chunyu/interrogation/delete', params).then(v => (v));
  },

  // 医生详情
  getDoctor(params) {
    return ajaxGet('/newapi/chunyu/interrogation/doctorDetailInfo', params).then(v => (v));
  },

  // 医生评价
  rate(params) {
    return ajaxGet('/newapi/chunyu/comment/create', params).then(v => (v));
  },

  // 问题详情 --
  getQuestionDetail(params) {
    return ajaxGet('/newapi/chunyu/interrogation/detail', params).then(v => (v));
  },

  // 上传图片 --
  uploadImage(params) {
    return mtAjax('/mobile/system/uploadimage.htm', params, 'POST').then(v => (v));
  },

  // 表单模拟多图上传图片 --
  uploadImageByForm(params) {
    params.formData.append('token', window.token);        // 添加token信息
    params.formData.append('isPrivateImage', 1);          // 添加isPrivateImage信息
    params.formData.append('isHttps', document.location.protocol === 'https:' ? 0 : 0); // https
    return Axios({
      method: params.type,
      url: params.url,
      data: params.formData,
    }).then(v => (v));
  },

  // base64 上传
  uploadBase64(params) {
    params.formData.append('token', window.token);        // 添加token信息
    params.formData.append('width', 600);
    params.formData.append('height', 600);
    params.formData.append('isHttps', document.location.protocol === 'https:' ? 0 : 0); // https
    params.formData.append('image', params.base64); // base64
    return Axios({
      method: params.type,
      url: params.url,
      data: params.formData,
    }).then(v => (v));
  },

  // 轮询医生反馈信息
  pollingLatestMsg(params) {
    return ajaxGet('/newapi/chunyu/interrogation/doctorAnswer', params).then(v => (v));
  },

  // 用户追问接口
  sendAskedMsg(params) {
    return ajaxGet('/newapi/chunyu/reQuest/userAppend', params).then(v => (v));
  },

  // 获取历史消息
  getHistoryMsg(params) {
    return ajaxGet('/newapi/chunyu/interrogation/detail', params).then(v => (v));
  },

  // 获取最新的消息
  getMsgUnread(params) {
    return ajaxGet('/newapi/chunyu/interrogation/listUnread', params).then(v => (v));
  },

  // 获取最新的消息
  readAudioMsg(params) {
    return ajaxGet('/newapi/chunyu/reQuest/updateReadStatus', params).then(v => (v));
  },

  // H5支付
  getH5ReqMsg(params) {
      return ajaxGet('/newapi/chunyu/order/pay', params).then(v => (v));
  },

  //微信支付
  getWechatReqMsg(params) {
      return ajaxGet('/newapi/bigHealth/order/pay', params).then(v => (v));
  },

  // 微信授权
  wxAuth(params) {
    return mtAjax('/mobile/weixin/authorization.htm', params, 'GET').then(v => (v));
  },

  // 获取后台配置的静态数据
  getConstantData(params) {
    return ajaxGet('/newapi/router/memberData/getConstantData', params).then(v => (v));
  },
  // 查询会员信息
  getUserMemberInfo(params) {
    return ajaxGet('/newapi/router/memberInfo/queryUserMemberInfo', params).then(v => (v));
  },
  // 去支持获取树币支付
  orderPay(params) {
    return ajaxGet('/newapi/bigHealth/order/pay', params).then(v => (v));
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js